/*==================================================
ALL 4 In Accordian
===================================================*/
// import React from "react";
// import "./HourlyFloatBookingModal.css";
// import Loader from "../../../../../Loader/Loader";
// import PhotographerAccordion from "./PhotographerAccordion";
// import HourlyBookingSummary from "./HourlyBookingSummary";
// import BookingInfoHeader from "./BookingInfoHeader";
// import useHourlyFloat from "./Hooks/useHourlyFloat";



// const HourlyFloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
//     const {
//         filteredPhotographers,
//         photographerSearch,
//         setPhotographerSearch,
//         selectAllChecked,
//         loadingPhotographers,
//         loadingAddBooking,
//         services,
//         isLock,
//         page,
//         setPage,
//         totalPages,
//         filters,
//         formData,
//         LIMIT,
//         handleSelectAll,
//         handlePhotographerToggle,
//         handleFilterChange,
//         resetFilters,
//         handleSubmit,
//         resetForm,
//     } = useHourlyFloat({ booking, isOpen, onClose, refetchData });

//     if (!isOpen) return null;
//     if (loadingAddBooking) return <Loader />;

//     return (
//         <div className="hourly-float-photographer-modal-overlay">
//             <div className="hourly-float-photographer-modal-container">

//                 {/* ── Header: booking info ── */}
//                 <BookingInfoHeader booking={booking} />

//                 {/* ── Hourly summary cards ── */}
//                 <HourlyBookingSummary hourlyPackages={booking?.hourlyPackages || []} />

//                 {/* ── Body: photographer selector ── */}
//                 <div className="hourly-modal-body">
//                     <form id="floatForm" onSubmit={handleSubmit} className="hourly-form">
//                         <PhotographerAccordion
//                             photographers={filteredPhotographers}
//                             photographerSearch={photographerSearch}
//                             onSearchChange={setPhotographerSearch}
//                             filters={filters}
//                             services={services}
//                             isLock={isLock}
//                             loadingPhotographers={loadingPhotographers}
//                             selectAllChecked={selectAllChecked}
//                             selectedIds={formData.photographerIds}
//                             page={page}
//                             totalPages={totalPages}
//                             LIMIT={LIMIT}
//                             onSelectAll={handleSelectAll}
//                             onToggle={handlePhotographerToggle}
//                             onPageChange={setPage}
//                             onFilterChange={handleFilterChange}
//                             onResetFilters={resetFilters}
//                         />
//                     </form>
//                 </div>

//                 {/* ── Footer: actions ── */}
//                 <div className="hourly-modal-footer">
//                     <button
//                         className="btn-secondary"
//                         type="button"
//                         onClick={() => { resetForm(); onClose(); }}
//                     >
//                         Cancel
//                     </button>

//                     <button
//                         className="btn-primary"
//                         type="submit"
//                         form="floatForm"
//                         disabled={isLock}
//                     >
//                         Send Photographer Request
//                     </button>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default HourlyFloatBookingModal;


import React, { useEffect } from "react";
import "./HourlyFloatBookingModal.css";



import useHourlyFloat from "./Hooks/useHourlyFloat";
import Loader from "../../../../../Loader/Loader";
import BookingInfoHeader from "./BookingInfoHeader";
import HourlyBookingSummary from "./HourlyBookingSummary";
import RoleAccordion from "./RoleAccordion";
import {
    resolveRoleKeysFromAccordion,
    roleKeyMatchesPackageServices,
} from "./hourlyFloatHelpers";
import { HOURLY_FLOAT_ROLES as ROLES } from "./hourlyFloatRoles";

// ─── Modal ────────────────────────────────────────────────────────────────────
const HourlyFloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
    const {
        services,
        loadingAddBooking,
        roleSelections,
        allPackagesSelections,
        selectedPackageIndex,
        setSelectedPackageIndex,
        handleRoleSelectionChange,
        handleSubmit,
        handleRoleSubmit,
        resetAll,
        refreshVersion,
        localBooking,
    } = useHourlyFloat({ booking, isOpen, onClose, refetchData });

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    if (!isOpen) return null;
    if (loadingAddBooking) return <Loader />;

    const accordionRoleKeys = resolveRoleKeysFromAccordion(localBooking);
    const currentPkg = localBooking?.hourlyPackages?.[selectedPackageIndex];

    const visibleRoles = ROLES.filter((role) => {
        if (accordionRoleKeys) {
            return accordionRoleKeys.includes(role.key);
        }
        return roleKeyMatchesPackageServices(role.key, currentPkg);
    });

    return (
        <div className="hourly-float-photographer-modal-overlay">
            <div className="hourly-float-photographer-modal-container">

                <BookingInfoHeader booking={localBooking} />

                <div className="hourly-modal-body">
                    <HourlyBookingSummary hourlyPackages={localBooking?.hourlyPackages || []} />

                    <div className="hourly-float-plan-section">
                        <span className="hourly-float-section-label">
                            1. Select plan to assign staff
                        </span>
                        <div className="plan-selector-global" role="group" aria-label="Select plan">
                            {(localBooking?.hourlyPackages || []).map((pkg, idx) => (
                                <label
                                    key={idx}
                                    className={`plan-chip${
                                        selectedPackageIndex === idx ? " plan-chip--active" : ""
                                    }`}
                                >
                                    <input
                                        type="radio"
                                        name="global-plan-select"
                                        checked={selectedPackageIndex === idx}
                                        onChange={() => setSelectedPackageIndex(idx)}
                                    />
                                    {pkg.category || "Standard"} ({pkg.hours})
                                </label>
                            ))}
                        </div>

                        <span className="hourly-float-section-label">
                            2. Choose staff for selected plan
                        </span>
                    </div>

                    <div className="hourly-float-staff-section">
                        <form id="floatForm" onSubmit={handleSubmit} className="hourly-form hourly-form--roles">
                            {visibleRoles.length === 0 ? (
                                <p className="text-muted" style={{ padding: "12px 0" }}>
                                    No staff role matches this plan
                                    {accordionRoleKeys?.length
                                        ? ` for “${localBooking?.role_accordian || "requirement"}”.`
                                        : "."}
                                </p>
                            ) : null}
                            {visibleRoles.map((role) => (
                                <RoleAccordion
                                    key={role.key}
                                    roleKey={role.key}
                                    title={role.title}
                                    bookingId={localBooking?.veroaBookingId || localBooking?._id}
                                    isOpen={isOpen}
                                    services={role.showFilters ? services : []}
                                    fetchListAPI={role.fetchListAPI}
                                    fetchAllAPI={role.fetchAllAPI}
                                    fetchSortAPI={role.fetchSortAPI}
                                    showFilters={role.showFilters}
                                    onSelectionChange={handleRoleSelectionChange}
                                    hourlyPackages={localBooking?.hourlyPackages || []}
                                    selectedPackageIndex={selectedPackageIndex}
                                    onPackageSelect={setSelectedPackageIndex}
                                    onAction={handleRoleSubmit}
                                    roleSelections={roleSelections}
                                    allPackagesSelections={allPackagesSelections}
                                    refreshVersion={refreshVersion}
                                />
                            ))}
                        </form>
                    </div>
                </div>

                <div className="hourly-modal-footer">
                    <button
                        className="btn-secondary"
                        type="button"
                        onClick={() => { resetAll(); onClose(); }}
                    >
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
};

export default HourlyFloatBookingModal;



// //SELECT ALL and ONLY one
//====================================================================

// import React, { useEffect, useRef, useState } from "react";
// import "./FloatBookingModal.css";
// import { toast } from "react-toastify";
// import Loader from "../../../../Loader/Loader";
// import { AssignPhotographerToBookingAPI, GetToFloatPhotographersgAPI, SortPhotographersAPI } from "../../../../utils/APIs/bookingsApis";

// import { useNavigate } from "react-router-dom";
// import { getServicesAPI } from "../../../../utils/APIs/servicesApis";

// const FloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
//     const [photographers, setPhotographers] = useState([]);
//     const [photographerSearch, setPhotographerSearch] = useState("");
//     // const [photographerDropdownOpen, setIsPhotographerDropdownOpen] = useState(false);
//     // const [allPhotographerIds, setAllPhotographerIds] = useState([]);
//     const [selectAllChecked, setSelectAllChecked] = useState(false);
//     const [loadingPhotographers, setLoadingPhotographers] = useState(false);
//     const [services, setServices] = useState([]);
//     const photographerDropdownRef = useRef(null);
//     const [filters, setFilters] = useState({
//         rating: "",
//         expertise: "",
//         category: "",
//     });
//     const [isLock, setIsLock] = useState(false);
//     // const [requirements, setRequirements] = useState([]);
//     const LIMIT = 10;

//     const [page, setPage] = useState(1);
//     const [total, setTotal] = useState(0);
//     console.log("BOOKING", booking)
//     const navigate = useNavigate()
//     const [formData, setFormData] = useState({
//         photographerIds: [],
//     });
//     const [loadingAddBooking, setLoadingAddBooking] = useState(false);
//     const formatDate = (date) => {
//         if (!date) return "-";

//         return new Date(date).toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//         });
//     };

//     const toCamelCase = (str) => {
//         if (!str) return "";
//         return str
//             .toLowerCase()
//             .replace(/[-_ ]+(.)/g, (_, c) => c.toUpperCase());
//     };

//     const handleSelectAll = async (e) => {
//         const checked = e.target.checked;
//         setSelectAllChecked(checked);

//         if (checked) {
//             try {
//                 const res = await GetToFloatPhotographersgAPI(1, total, booking.bookingId);

//                 const allIds = res?.data?.data?.map((p) => p._id) || [];

//                 setFormData((prev) => ({
//                     ...prev,
//                     photographerIds: allIds,
//                 }));
//             } catch (error) {
//                 console.error("Failed to fetch all photographers", error);
//             }
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 photographerIds: [],
//             }));
//         }
//     };
//     useEffect(() => {
//         const handleClickOutside = (event) => {

//             // if (
//             //     photographerDropdownRef.current &&
//             //     !photographerDropdownRef.current.contains(event.target)
//             // ) {
//             //     setIsPhotographerDropdownOpen(false);
//             // }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);
//     useEffect(() => {
//         if (!isOpen) return;

//         fetchPhotographers(page);
//         setSelectAllChecked(false);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [isOpen, page]);

//     const totalPages = Math.ceil(total / LIMIT);

//     const getPageNumbers = () => {
//         const pages = [];
//         for (let i = 1; i <= totalPages; i++) {
//             pages.push(i);
//         }
//         return pages;
//     };

//     // const fetchPhotographers = async (pageNo = page) => {
//     //     try {
//     //         setLoadingPhotographers(true);

//     //         const res = await GetToFloatPhotographersgAPI(pageNo, LIMIT);

//     //         setPhotographers(res?.data?.data || []);
//     //         setTotal(res?.data?.meta?.total || 0);
//     //         setPage(res?.data?.meta?.page || pageNo);
//     //         // store ids
//     //         // const ids = res?.data?.data?.map((p) => p._id);
//     //         // setAllPhotographerIds((prev) => [...new Set([...prev, ...ids])]);

//     //     } catch (error) {
//     //         console.error("Photographer fetch failed", error);
//     //     } finally {
//     //         setLoadingPhotographers(false);
//     //     }
//     // };

//     const fetchPhotographers = async (pageNo = page) => {
//         try {
//             setLoadingPhotographers(true);

//             let res;

//             // ✅ If any filter is applied → use SORT API
//             if (filters.rating || filters.expertise || filters.category) {
//                 res = await SortPhotographersAPI(filters, pageNo, LIMIT, booking.bookingId);
//                 setPhotographers(res?.data?.data || []);
//                 setTotal(res?.data?.meta?.total || res?.data?.data?.length || 0);
//                 setPage(res?.data?.meta?.page || pageNo);
//                 setIsLock(res?.data?.isLock || false);
//             } else {
//                 // ✅ Default list (paginated)
//                 res = await GetToFloatPhotographersgAPI(pageNo, LIMIT, booking.bookingId);
//                 setPhotographers(res?.data?.data || []);
//                 setTotal(res?.data?.meta?.total || 0);
//                 setPage(res?.data?.meta?.page || pageNo);
//                 setIsLock(res?.data?.isLock || false);
//             }

//         } catch (error) {
//             console.error("Photographer fetch failed", error);
//         } finally {
//             setLoadingPhotographers(false);
//         }
//     };

//     useEffect(() => {
//         if (!isOpen) return;
//         fetchPhotographers(1);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [filters, isOpen,]);

//     useEffect(() => {
//         if (!isOpen) return;

//         const fetchServices = async () => {
//             try {
//                 const res = await getServicesAPI();
//                 setServices(res?.data?.data || []);
//             } catch (err) {
//                 console.error("Failed to fetch services", err);
//             }
//         };

//         fetchServices();
//     }, [isOpen]);



//     if (!isOpen) return null;


//     const filteredPhotographers = (photographers || []).filter((p) =>
//         p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
//         (p.mobileNumber || p.phone)?.includes(photographerSearch)
//     );

//     const resetForm = () => {
//         setFormData({
//             photographerIds: [],
//         });

//         setSelectAllChecked(false);
//         setPhotographerSearch("");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formData.photographerIds.length === 0) {
//             toast.error("Please select at least one photographer");
//             return;
//         }

//         try {
//             setLoadingAddBooking(true);

//             // const payload = {
//             //     bookingId: booking.bookingId,
//             //     photographerIds: formData.photographerIds,
//             // };
//             let payload = {
//                 bookingId: booking.bookingId,
//             };

//             if (formData.photographerIds.length === 1) {
//                 payload.photographerId = formData.photographerIds[0];
//             } else {
//                 payload.photographerIds = formData.photographerIds;
//             }

//             const response = await AssignPhotographerToBookingAPI(payload);

//             if (response?.data?.success) {
//                 toast.success(
//                     response?.data?.message ||
//                     "Photographer request sent successfully!"
//                 );

//                 refetchData();
//                 resetForm();
//                 onClose();
//             } else {
//                 toast.error(response?.data?.message || "Failed to send request!");
//             }
//         } catch (error) {
//             console.error("Assign Booking Error:", error);
//             toast.error("Something went wrong");
//         } finally {
//             setLoadingAddBooking(false);
//         }
//     };
//     if (loadingAddBooking) {
//         return <Loader />
//     }
//     return (
//         <div className="float-photographer-modal-overlay">
//             <div className="float-photographer-modal-container">

//                 <div className="float-photographer-modal-header">
//                     <h3>Float booking </h3>

//                     <div className="booking-info-grid">
//                         <div className="booking-info-item">
//                             <span>Booking ID</span>
//                             <p>{booking?.veroaBookingId || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Amount</span>
//                             <p>₹ {booking?.bookingAmount || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Event Type</span>
//                             <p>{booking?.eventType || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Location</span>
//                             <p>{booking?.location || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Start Date</span>
//                             <p>
//                                 {formatDate(booking.startDate) || "-"}
//                             </p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>End Date</span>
//                             <p>
//                                 {formatDate(booking.endDate) || "-"}
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="assign-photographer-modal-body">
//                     <form id="floatForm" onSubmit={handleSubmit} className="assign-photographer-form">



//                         {/* Photographer Dropdown (like customer) */}
//                         <div className="form-group" style={{ gridColumn: "span 2" }}>
//                             <label>Float Photographer *</label>

//                             <div className="user-dropdown" ref={photographerDropdownRef}>
//                                 <div className="dropdown-input-wrapper">
//                                     <input
//                                         type="text"
//                                         placeholder="Search Photographer by name or mobile..."
//                                         value={photographerSearch}
//                                         onChange={(e) => {
//                                             setPhotographerSearch(e.target.value);
//                                             // setIsPhotographerDropdownOpen(true);

//                                         }}
//                                         disabled={isLock}
//                                     // onFocus={() => setIsPhotographerDropdownOpen(true)}
//                                     />
//                                     <span className="dropdown-arrow">▼</span>
//                                 </div>


//                                 <div className="filter-container">
//                                     {/* Rating */}
//                                     <div className="filter-item">
//                                         <label>Rating</label>
//                                         <select
//                                             value={filters.rating}
//                                             onChange={(e) =>
//                                                 setFilters({ ...filters, rating: e.target.value })
//                                             }
//                                             disabled={isLock}
//                                         >
//                                             <option value="">All</option>
//                                             <option value="5">⭐ 5</option>
//                                             <option value="4">⭐ 4</option>
//                                             <option value="3">⭐ 3</option>
//                                             <option value="2">⭐ 2</option>
//                                             <option value="1">⭐ 1</option>





//                                         </select>
//                                     </div>

//                                     {/* Category (FIXED) */}
//                                     <div className="filter-item">
//                                         <label>Category</label>
//                                         <select
//                                             value={filters.category}
//                                             onChange={(e) =>
//                                                 setFilters({ ...filters, category: e.target.value })
//                                             }
//                                             disabled={isLock}
//                                         >
//                                             <option value="">All</option>

//                                             {services.map((service) => (
//                                                 <option key={service._id} value={toCamelCase(service.serviceName || service.key)}>
//                                                     {service.serviceName}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* Expertise (FIXED) */}
//                                     <div className="filter-item">
//                                         <label>Expertise</label>
//                                         <select
//                                             value={filters.expertise}
//                                             onChange={(e) =>
//                                                 setFilters({ ...filters, expertise: e.target.value })
//                                             }
//                                             disabled={isLock}
//                                         >
//                                             <option value="">All</option>
//                                             <option value="initio">INITIO</option>
//                                             <option value="elite">ELITE</option>
//                                             <option value="pro">PRO</option>
//                                         </select>
//                                     </div>

//                                     {/* Reset */}
//                                     <div className="filter-actions">
//                                         <button
//                                             type="button"
//                                             className="btn-reset"
//                                             onClick={() =>
//                                                 setFilters({ rating: "", expertise: "", category: "" })
//                                             }
//                                             disabled={isLock}
//                                         >
//                                             Reset
//                                         </button>
//                                     </div>
//                                 </div>
//                                 <div className="assign-photographer-dropdown-list">



//                                     {loadingPhotographers ? (
//                                         <div className="dropdown-status">Loading photographers...</div>
//                                     ) : filteredPhotographers.length === 0 ? (
//                                         <div className="dropdown-empty">
//                                             <p>No photographer found</p>
//                                             <button
//                                                 type="button"
//                                                 className="btn-primary"
//                                                 onClick={() => {
//                                                     // setIsPhotographerDropdownOpen(false);
//                                                     navigate("/photographer");
//                                                 }}
//                                             >
//                                                 + Add New Photographer
//                                             </button>
//                                         </div>
//                                     ) : (

//                                         <table className="photographer-table">
//                                             <thead>
//                                                 <tr>
//                                                     <th>
//                                                         <div className="checkbox-sr-header">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 onChange={handleSelectAll}
//                                                                 checked={selectAllChecked}
//                                                                 disabled={isLock}
//                                                             />
//                                                             <span>Sr.</span>
//                                                         </div>
//                                                     </th>

//                                                     <th>Photographer Name</th>
//                                                     <th>Category</th>
//                                                     <th>Level</th>
//                                                     <th>Commission</th>
//                                                     <th>Avg. Rating</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody>
//                                                 {filteredPhotographers.map((photographer, index) => {
//                                                     const isChecked = formData.photographerIds.includes(photographer._id);
//                                                     const disableRow =
//                                                         formData.photographerIds.length === 1 && !isChecked && !selectAllChecked;
//                                                     return (
//                                                         <tr key={photographer._id}>
//                                                             <td>
//                                                                 <div className="checkbox-sr-cell">
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={isChecked || photographer.isAssigned}
//                                                                         disabled={isLock || photographer.isAssigned || disableRow}
//                                                                         onChange={(e) => {
//                                                                             const checked = e.target.checked;

//                                                                             setFormData((prev) => ({
//                                                                                 ...prev,
//                                                                                 photographerIds: checked
//                                                                                     ? [...prev.photographerIds, photographer._id]
//                                                                                     : prev.photographerIds.filter((id) => id !== photographer._id),
//                                                                             }));
//                                                                         }}
//                                                                     />
//                                                                     <span> {(page - 1) * LIMIT + index + 1}</span>
//                                                                 </div>
//                                                             </td>

//                                                             <td>{photographer.name || "-"}</td>
//                                                             <td>
//                                                                 {photographer.categories?.length > 0
//                                                                     ? photographer.categories.join(", ")
//                                                                     : "-"}
//                                                             </td>
//                                                             <td>{photographer.level || photographer.expertiseLevel || "-"}</td>
//                                                             <td>{photographer.commissionPercentage || "-"}%</td>
//                                                             <td>
//                                                                 {photographer.avgRating != null
//                                                                     ? `⭐ ${Number(photographer.avgRating).toFixed(1)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>


//                                     )}
//                                     {totalPages > 1 && filteredPhotographers.length > 0 && (
//                                         <div className="pagination">
//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === 1}
//                                                 onClick={() => setPage(page - 1)}
//                                             >
//                                                 Prev
//                                             </button>

//                                             {getPageNumbers().map((p) => (
//                                                 <button
//                                                     type="button"
//                                                     key={p}
//                                                     className={`pagination-btn ${p === page ? "active" : ""}`}
//                                                     onClick={() => setPage(p)}
//                                                 >
//                                                     {p}
//                                                 </button>
//                                             ))}

//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === totalPages}
//                                                 onClick={() => setPage(page + 1)}
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>

//                             </div>

//                         </div>





//                     </form>
//                 </div>

//                 <div className="quote-modal-footer">
//                     <button className="btn-secondary" type="button"
//                         onClick={() => {
//                             resetForm();
//                             onClose();
//                         }}>
//                         Cancel
//                     </button>
//                     <button className="btn-primary" type="submit" form="floatForm" disabled={isLock}>
//                         Send Photographer Request
//                     </button>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default FloatBookingModal;



//=============================================================
//PARTIALLY SELECT

// import React, { useEffect, useRef, useState } from "react";
// import "./FloatBookingModal.css";
// import { toast } from "react-toastify";
// import Loader from "../../../../Loader/Loader";
// import { AssignPhotographerToBookingAPI, GetToFloatPhotographersgAPI } from "../../../../utils/APIs/bookingsApis";
// import { getVerifiedPhotographersAPI } from "../../../../utils/APIs/photographersApis";
// import { useNavigate } from "react-router-dom";

// const FloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
//     const [photographers, setPhotographers] = useState([]);
//     const [photographerSearch, setPhotographerSearch] = useState("");
//     const [photographerDropdownOpen,setIsPhotographerDropdownOpen] = useState(false);
//     const [allPhotographerIds, setAllPhotographerIds] = useState([]);
//     const [selectAllChecked, setSelectAllChecked] = useState(false);
//     const [loadingPhotographers, setLoadingPhotographers] = useState(false);
//     const photographerDropdownRef = useRef(null);
//     // const [requirements, setRequirements] = useState([]);
//     const LIMIT = 10;

//     const [page, setPage] = useState(1);
//     const [total, setTotal] = useState(0);
//     console.log("BOOKING", booking)
//     const navigate = useNavigate()
//     const [formData, setFormData] = useState({
//         photographerIds: [],
//     });
//     const [loadingAddBooking, setLoadingAddBooking] = useState(false);
//     const formatDate = (date) => {
//         if (!date) return "-";

//         return new Date(date).toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//         });
//     };

//    const handleSelectAll = async (e) => {
//     const checked = e.target.checked;
//     setSelectAllChecked(checked);

//     if (checked) {
//         try {
//             const res = await GetToFloatPhotographersgAPI(1, total);

//             const allIds = res?.data?.data?.map((p) => p._id) || [];

//             setFormData((prev) => ({
//                 ...prev,
//                 photographerIds: allIds,
//             }));
//         } catch (error) {
//             console.error("Failed to fetch all photographers", error);
//         }
//     } else {
//         setFormData((prev) => ({
//             ...prev,
//             photographerIds: [],
//         }));
//     }
// };
//     useEffect(() => {
//         const handleClickOutside = (event) => {

//             if (
//                 photographerDropdownRef.current &&
//                 !photographerDropdownRef.current.contains(event.target)
//             ) {
//                 setIsPhotographerDropdownOpen(false);
//             }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);
//     useEffect(() => {
//         if (!isOpen) return;

//         fetchPhotographers(page);
//         setSelectAllChecked(false);
//     }, [isOpen, page]);

//     const totalPages = Math.ceil(total / LIMIT);

//     const getPageNumbers = () => {
//         const pages = [];
//         for (let i = 1; i <= totalPages; i++) {
//             pages.push(i);
//         }
//         return pages;
//     };

//     const fetchPhotographers = async (pageNo = page) => {
//         try {
//             setLoadingPhotographers(true);

//             const res = await GetToFloatPhotographersgAPI(pageNo, LIMIT);

//             setPhotographers(res?.data?.data || []);
//             setTotal(res?.data?.meta?.total || 0);
//             setPage(res?.data?.meta?.page || pageNo);
//                 // store ids
//         const ids = res?.data?.data?.map((p) => p._id);
//         setAllPhotographerIds((prev) => [...new Set([...prev, ...ids])]);

//         } catch (error) {
//             console.error("Photographer fetch failed", error);
//         } finally {
//             setLoadingPhotographers(false);
//         }
//     };



//     if (!isOpen) return null;


//     const filteredPhotographers = photographers.filter((p) =>
//         p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
//         p.mobileNumber?.includes(photographerSearch)
//     );

//     const resetForm = () => {
//         setFormData({
//             photographerIds: [],
//         });

//         setSelectAllChecked(false);
//         setPhotographerSearch("");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formData.photographerIds.length === 0) {
//             toast.error("Please select at least one photographer");
//             return;
//         }

//         try {
//             setLoadingAddBooking(true);

//             const payload = {
//                 bookingId: booking.bookingId,
//                 photographerIds: formData.photographerIds,
//             };

//             const response = await AssignPhotographerToBookingAPI(payload);

//             if (response?.data?.success) {
//                 toast.success(
//                     response?.data?.message ||
//                     "Photographer request sent successfully!"
//                 );

//                 refetchData();
//                 resetForm();
//                 onClose();
//             } else {
//                 toast.error(response?.data?.message || "Failed to send request!");
//             }
//         } catch (error) {
//             console.error("Assign Booking Error:", error);
//             toast.error("Something went wrong");
//         } finally {
//             setLoadingAddBooking(false);
//         }
//     };
//     if (loadingAddBooking) {
//         return <Loader />
//     }
//     return (
//         <div className="float-photographer-modal-overlay">
//             <div className="float-photographer-modal-container">

//                 <div className="float-photographer-modal-header">
//                     <h3>Float booking </h3>

//                     <div className="booking-info-grid">
//                         <div className="booking-info-item">
//                             <span>Booking ID</span>
//                             <p>{booking?.veroaBookingId || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Amount</span>
//                             <p>₹ {booking?.bookingAmount || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Event Type</span>
//                             <p>{booking?.eventType || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Location</span>
//                             <p>{booking?.location || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Start Date</span>
//                             <p>
//                                 {formatDate(booking.startDate) || "-"}
//                             </p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>End Date</span>
//                             <p>
//                                 {formatDate(booking.endDate) || "-"}
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="assign-photographer-modal-body">
//                     <form id="floatForm" onSubmit={handleSubmit} className="assign-photographer-form">



//                         {/* Photographer Dropdown (like customer) */}
//                         <div className="form-group" style={{ gridColumn: "span 2" }}>
//                             <label>Float Photographer *</label>

//                             <div className="user-dropdown" ref={photographerDropdownRef}>
//                                 <div className="dropdown-input-wrapper">
//                                     <input
//                                         type="text"
//                                         placeholder="Search Photographer by name or mobile..."
//                                         value={photographerSearch}
//                                         onChange={(e) => {
//                                             setPhotographerSearch(e.target.value);
//                                             setIsPhotographerDropdownOpen(true);
//                                         }}
//                                         onFocus={() => setIsPhotographerDropdownOpen(true)}
//                                     />
//                                     <span className="dropdown-arrow">▼</span>
//                                 </div>

//                                 {/* {isPhotographerDropdownOpen && (
//                                     <div className="assign-photographer-dropdown-list">
//                                         {loadingPhotographers ? (
//                                             <div className="dropdown-status">Loading photographers...</div>
//                                         ) : filteredPhotographers.length === 0 ? (
//                                             <div className="dropdown-empty">
//                                                 <p>No photographer found</p>
//                                                 <button
//                                                     type="button"
//                                                     className="btn-primary"
//                                                     onClick={() => {
//                                                         setIsPhotographerDropdownOpen(false);
//                                                         navigate("/photographer")
//                                                     }}
//                                                 >
//                                                     + Add New Photographer
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             filteredPhotographers.map((photographer) => (
//                                                 <div
//                                                     key={photographer._id}
//                                                     className={`assign-photographer-dropdown-item ${formData.photographerId === photographer._id ? "selected" : ""
//                                                         }`}
//                                                     onClick={() => {
//                                                         setFormData({
//                                                             ...formData,
//                                                             photographerId: photographer._id,
//                                                         });

//                                                         setPhotographerSearch(
//                                                             photographer.name || photographer.phone || photographer?.email);

//                                                         setIsPhotographerDropdownOpen(false);
//                                                     }}
//                                                 >

//                                                     <div className="user-name">{photographer.name}</div>
//                                                     <div className="user-mobile">
//                                                         {photographer.phone}
//                                                     </div>
//                                                     {photographer.email && (
//                                                         <div className="user-email">{photographer.email}</div>
//                                                     )}
//                                                     <hr className="my-toggle-text" />
//                                                 </div>
//                                             ))
//                                         )}
//                                     </div>
//                                 )} */}
//                                 {/* {isPhotographerDropdownOpen && ( */}
//                                 <div className="assign-photographer-dropdown-list">

//                                     {loadingPhotographers ? (
//                                         <div className="dropdown-status">Loading photographers...</div>
//                                     ) : filteredPhotographers.length === 0 ? (
//                                         <div className="dropdown-empty">
//                                             <p>No photographer found</p>
//                                             <button
//                                                 type="button"
//                                                 className="btn-primary"
//                                                 onClick={() => {
//                                                     setIsPhotographerDropdownOpen(false);
//                                                     navigate("/photographer");
//                                                 }}
//                                             >
//                                                 + Add New Photographer
//                                             </button>
//                                         </div>
//                                     ) : (

//                                         <table className="photographer-table">
//                                             <thead>
//                                                 <tr>
//                                                     <th>
//                                                         <div className="checkbox-sr-header">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 onChange={handleSelectAll}
//                                                                 checked={selectAllChecked}
//                                                             />
//                                                             <span>Sr.</span>
//                                                         </div>
//                                                     </th>

//                                                     <th>Photographer Name</th>
//                                                     <th>Level</th>
//                                                     <th>Commission</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody>
//                                                 {filteredPhotographers.map((photographer, index) => {
//                                                     const isChecked = formData.photographerIds.includes(photographer._id);

//                                                     return (
//                                                         <tr key={photographer._id}>
//                                                             <td>
//                                                                 <div className="checkbox-sr-cell">
//                                                                    <input
//   type="checkbox"
//   checked={formData.photographerIds.includes(photographer._id)}
//   onChange={(e) => {
//     const checked = e.target.checked;
// console.log("Photographer:", photographer);   // 👈 ADD THIS
//     console.log("Photographer ID:", photographer._id); // 👈 ADD THIS

//     setFormData((prev) => ({
//       ...prev,
//       photographerIds: checked
//         ? [...prev.photographerIds, photographer._id]
//         : prev.photographerIds.filter((id) => id !== photographer._id),
//     }));
//   }}
// />
//                                                                     <span> {(page - 1) * LIMIT + index + 1}</span>
//                                                                 </div>
//                                                             </td>

//                                                             <td>{photographer.name || "-"}</td>
//                                                             <td>{photographer.level || "-"}</td>
//                                                             <td>{photographer.commissionPercentage || "-"}%</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>


//                                     )}
//                                     {totalPages > 1 && (
//                                         <div className="pagination">
//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === 1}
//                                                 onClick={() => setPage(page - 1)}
//                                             >
//                                                 Prev
//                                             </button>

//                                             {getPageNumbers().map((p) => (
//                                                 <button
//                                                     type="button"
//                                                     key={p}
//                                                     className={`pagination-btn ${p === page ? "active" : ""}`}
//                                                     onClick={() => setPage(p)}
//                                                 >
//                                                     {p}
//                                                 </button>
//                                             ))}

//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === totalPages}
//                                                 onClick={() => setPage(page + 1)}
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>

//                             </div>

//                         </div>





//                     </form>
//                 </div>

//                 <div className="quote-modal-footer">
//                     <button className="btn-secondary" type="button"
//                         onClick={() => {
//                             resetForm();
//                             onClose();
//                         }}>
//                         Cancel
//                     </button>
//                     <button className="btn-primary" type="submit" form="floatForm">
//                         Send Photographer Request
//                     </button>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default FloatBookingModal;